import type {
	DamagePolygonListSuccessResponseType,
	DamagePolygonQueryParams,
} from '@/common/damage-polygon';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export async function getDamagePolygons(
	query: DamagePolygonQueryParams
): Promise<DamagePolygonListSuccessResponseType | null> {
	const url = API_URLS.DAMAGE_POLYGONS.INDEX;

	const cleanParams = Object.fromEntries(
		Object.entries(query).filter(([_, v]) => v != null && v !== '')
	);

	const response = await axios.get(url, {
		params: cleanParams,
	});

	return getResponse<DamagePolygonListSuccessResponseType>(response.data);
}
